import { RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from 'store'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { ErrorBoundary } from 'react-error-boundary'
import { router } from 'app/router'
import { MainToolbarProvider } from 'shared/contexts/MainToolbarContext'
import { useRealViewportHeight } from 'shared/hooks/useRealViewportHeight'
import { EventBusProvider } from 'shared/providers/EventBusProvider'

export const App = () => {
    useRealViewportHeight()
  
    return (
        <ErrorBoundary fallback={<div>Something went wrong</div>}>
            <Provider store={store}>
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                    <EventBusProvider>
                        <MainToolbarProvider>
                            <RouterProvider router={router} />
                        </MainToolbarProvider>
                    </EventBusProvider>
                </LocalizationProvider>
            </Provider>
        </ErrorBoundary>
    )
}